import React, { useContext, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './AdminPanel.css';
import { AuthContext } from '../../../context/AuthContext';
import DashboardLayout from '../../Dashboard/DashboardLayout';
import AdminOverview from './AdminOverview';
import AdminActivity from './AdminActivity';
import AdminFraud from './AdminFraud';
import AdminUserList from './AdminUserList';
import AdminUserDetail from './AdminUserDetail';

const AdminPanel = () => {
  const navigate = useNavigate();
  const { user, loading: authLoading } = useContext(AuthContext);
  const [tab, setTab] = useState('overview');
  const [selectedUserId, setSelectedUserId] = useState(null);
  const [userListKey, setUserListKey] = useState(0);

  useEffect(() => {
    if (!authLoading && !user) {
      navigate('/login', { replace: true });
      return;
    }
    if (!authLoading && user && user.admin !== true) {
      navigate('/wallets', { replace: true });
    }
  }, [authLoading, user, navigate]);

  if (authLoading || !user || user.admin !== true) {
    return (
      <DashboardLayout>
        <div className="admin-loading">Loading...</div>
      </DashboardLayout>
    );
  }

  return (
    <DashboardLayout>
      <div className="admin-container">
        <div className="admin-header">
          <h1>Admin Dashboard</h1>
          <div className="admin-tabs">
            <button
              className={`admin-tab ${tab === 'overview' ? 'active' : ''}`}
              onClick={() => setTab('overview')}
            >
              Overview
            </button>
            <button
              className={`admin-tab ${tab === 'activity' ? 'active' : ''}`}
              onClick={() => setTab('activity')}
            >
              Activity
            </button>
            <button
              className={`admin-tab ${tab === 'users' ? 'active' : ''}`}
              onClick={() => setTab('users')}
            >
              Users
            </button>
            <button
              className={`admin-tab ${tab === 'fraud' ? 'active' : ''}`}
              onClick={() => setTab('fraud')}
            >
              Fraud
            </button>
          </div>
        </div>

        {tab === 'overview' && <AdminOverview />}
        {tab === 'activity' && <AdminActivity onSelectUser={setSelectedUserId} />}
        {tab === 'fraud' && <AdminFraud onSelectUser={setSelectedUserId} />}
        {tab === 'users' && (
          <AdminUserList key={userListKey} onSelectUser={setSelectedUserId} />
        )}
      </div>

      {selectedUserId && (
        <AdminUserDetail
          uid={selectedUserId}
          onClose={() => setSelectedUserId(null)}
          onChanged={() => setUserListKey((k) => k + 1)}
          onSelectUser={setSelectedUserId}
        />
      )}
    </DashboardLayout>
  );
};

export default AdminPanel;
